import { Controller } from "@hotwired/stimulus"

export default class ChatWidgetController extends Controller {
  static targets = ["messages", "input", "button", "container"]
  
  connect() {
    console.log("ChatWidget connected!")
    this.loadHistory()
  }

  async loadHistory() {
    try {
      const response = await fetch("/api/chat/history")
      const data = await response.json()
      
      if (data.messages && data.messages.length > 0) {
        this.renderMessages(data.messages)
      }
    } catch (e) {
      console.error("Failed to load history:", e)
    }
  }

  async sendMessage() {
    const content = this.inputTarget.value.trim()
    if (!content) return

    this.inputTarget.value = ""
    this.addMessage("user", content)
    this.setLoading(true)

    try {
      const response = await fetch("/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: content })
      })
      
      const data = await response.json()
      
      if (data.reply) {
        this.addMessage("assistant", data.reply)
      } else if (data.error) {
        this.addMessage("assistant", `错误: ${data.error}`)
      }
    } catch (e) {
      this.addMessage("assistant", "请求失败，请稍后重试")
    } finally {
      this.setLoading(false)
      this.scrollToBottom()
    }
  }

  addMessage(role, content) {
    const messageDiv = document.createElement("div")
    messageDiv.className = role === "user" 
      ? "flex justify-end mb-3" 
      : "flex justify-start mb-3"
    
    const bubbleClass = role === "user"
      ? "bg-primary-600 text-white rounded-lg px-4 py-2 max-w-[80%]"
      : "bg-gray-100 text-gray-800 rounded-lg px-4 py-2 max-w-[80%]"
    
    messageDiv.innerHTML = `
      <div class="${bubbleClass} text-sm whitespace-pre-wrap">${this.escapeHtml(content)}</div>
    `
    
    this.messagesTarget.appendChild(messageDiv)
    this.scrollToBottom()
  }

  renderMessages(messages) {
    messages.forEach(msg => {
      this.addMessage(msg.role, msg.content)
    })
  }

  scrollToBottom() {
    setTimeout(() => {
      this.messagesTarget.scrollTop = this.messagesTarget.scrollHeight
    }, 50)
  }

  setLoading(loading) {
    this.buttonTarget.disabled = loading
    this.inputTarget.disabled = loading
    if (loading) {
      this.addMessage("assistant", "正在思考...")
      this.loadingMessage = this.messagesTarget.lastElementChild
    } else if (this.loadingMessage) {
      this.loadingMessage.remove()
      this.loadingMessage = null
    }
  }

  toggle() {
    console.log("Toggle called!")
    console.log("Container:", this.containerTarget)
    this.containerTarget.classList.toggle("hidden")
  }

  handleKeydown(event) {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault()
      this.sendMessage()
    }
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}